import axios from "axios";
import { API_BASE as SBIN_API_BASE } from "./base";

const API = SBIN_API_BASE;

const authHeaders = (token) => {
  const authToken = token || null;
  return authToken
    ? {
        Authorization: `Bearer ${authToken}`,
        "Content-Type": "application/json",
      }
    : { "Content-Type": "application/json" };
};

export async function getRewardsSettings(token) {
  const res = await axios.get(`${API}/rewards/settings`, {
    headers: authHeaders(token),
  });
  return res.data;
}

export async function updateRewardsSettings(payload, token) {
  const res = await axios.put(`${API}/rewards/settings`, payload, {
    headers: authHeaders(token),
  });
  return res.data;
}

export async function getClientRewards(clientId, token) {
  const res = await axios.get(`${API}/rewards/clients/${clientId}/rewards`, {
    headers: authHeaders(token),
  });
  return res.data;
}

export async function getClientRewardTransactions(clientId, params = {}, token) {
  const res = await axios.get(
    `${API}/rewards/clients/${clientId}/rewards/transactions`,
    {
      params,
      headers: authHeaders(token),
    }
  );
  return res.data;
}

export async function adjustClientRewards(clientId, payload, token) {
  const res = await axios.post(
    `${API}/rewards/clients/${clientId}/rewards/adjust`,
    payload,
    {
      headers: authHeaders(token),
    }
  );
  return res.data;
}

export async function lookupReferralCode(code, token) {
  const res = await axios.get(`${API}/rewards/referral/lookup`, {
    params: { code },
    headers: authHeaders(token),
  });
  return res.data;
}

export async function linkClientReferral(clientId, payload, token) {
  const res = await axios.post(
    `${API}/rewards/clients/${clientId}/referral/link`,
    payload,
    {
      headers: authHeaders(token),
    }
  );
  return res.data;
}

export async function redeemTicketRewards(ticketId, payload, token) {
  const res = await axios.post(
    `${API}/rewards/tickets/${ticketId}/rewards/redeem`,
    payload,
    {
      headers: authHeaders(token),
    }
  );
  return res.data;
}
